var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"welcome"},[_c('div',[_vm._v("沅陵茶叶好帮手")]),_c('img',{attrs:{"src":"/static/images/qrcode.jpg","alt":""}})])}]

export { render, staticRenderFns }